import { getCalendarByCalendarId } from 'owa-calendar-cache';
import { calendarPickerPlaceholderText } from '../calendar.locstring.json';
import loc from 'owa-localize';

export default function getDisplayNameForCalendar(calendarId: string): string {
    return getCalendarByCalendarId(calendarId)?.displayName || loc(calendarPickerPlaceholderText);
}
